<template>
    <section class="tekst blue">
        <circles-layout></circles-layout>
        <h1>OGT Academie</h1>
        <p>De medewerkers van Onderwijsgroep Tilburg maken het mogelijk om iedere dag weer het beste onderwijs aan leerlingen en studenten te bieden. Daarom is professionalisering van onze medewerkers een belangrijk thema. Naast alle bestaande in- en externe scholingsmogelijkheden, hebben we in 2020 een online leeromgeving geïntroduceerd: de OGT Academie. OGT Academie is gratis en toegankelijk voor elke medewerker van Onderwijsgroep Tilburg.</p>

        <p>We werken toe naar een professionele en lerende cultuur. Een cultuur waarin uitdagingen en kansen worden gecre&euml;erd, maar ook een cultuur waarin eisen worden gesteld aan de professionele ontwikkeling van onze medewerkers.</p>

        <p>Momenteel bieden we meer dan 700 cursussen aan, ondergebracht in vier leerlijnen.</p>

        <ol>
            <li><strong>Medewerker 3.0.</strong> Deze trainingen dragen bij aan het vergroten van zowel persoonlijke als professionele ontwikkeling.</li>
            <li><strong>Team 3.0.</strong> Deze trainingen dragen bij aan een succesvolle teamontwikkeling.</li>
            <li><strong>Onderwijs 3.0.</strong> Deze trainingen ondersteunen bij het verzorgen van eigentijds en toekomstgericht onderwijs.</li>
            <li><strong>Digitaliseren 3.0.</strong> Deze trainingen ondersteunen je bij het verbeteren van digitale vaardigheden.</li>
        </ol>
    </section>
</template>

<style lang="scss" scoped>
    // see /static/scss/pages/_tekst.scss
</style>

<script>
    import Circles from '@/app/components/circles';
    export default {
        name: 'MedewerkerIntro2',
        meta: {
            title: 'MedewerkerIntro2',
            color: '#36B1CA'
        },
        components: {
            'circles-layout': Circles
        },
        methods: {
            focus()
            {
                // console.log( 'animateIn' );
            }
        }
    };
</script>
